import { TRANSLATION_KEYS } from '../../../../translations'
import { getNavigationSteps } from '../../../navigation'

const baseSteps = [
  TRANSLATION_KEYS.navigation.settings,
  TRANSLATION_KEYS.navigation.documentAtGlance,
  TRANSLATION_KEYS.navigation.planAchievement,
  TRANSLATION_KEYS.navigation.sobAchievement,
  TRANSLATION_KEYS.navigation.initiatives,
]

const exportStep = TRANSLATION_KEYS.navigation.export
const competitorsStep = TRANSLATION_KEYS.navigation.sobCompetitors

export const QBR_DOCUMENT_DETAILS_STEPS = getNavigationSteps([...baseSteps, exportStep])

export const QBR_DOCUMENT_DETAILS_WITH_COMPETITORS = getNavigationSteps([
  ...baseSteps,
  competitorsStep,
  exportStep,
])
